import request from '@/service/request'
/*  微信商户管理 api */

/* 微信商户管理 page接口
*  @params/keyword 关键字
* */
export const pageWechatMerchantApi = (params) => {
  return request.post('/pay/wxMch/page', params)
}

/* 微信商户管理 根据id获取
*  @params/id
* */
export const getWechatMerchantByIdApi = (id) => {
  return request.post(`/pay/wxMch/getById/${id}`)
}
/* 微信商户管理 保存接口
* */
export const saveWechatMerchantApi = (params) => {
  return request.post('/pay/wxMch/save', params)
}
/* 微信商户管理 启用
*  @params {string} id
* */
export const enableWechatMerchantApi = (id) => {
  return request.post(`/pay/wxMch/enable/${id}`)
}
/* 微信商户管理 删除
*  @params {string}  id
* */
export const delWechatMerchantByIdApi = (id) => {
  return request.post(`/pay/wxMch/del/${id}`)
}

// 微信商户管理 下载私钥证书文件
export const downloadWechatShopPrivateCert = (id, filename = '私钥证书') => {
  return request.get(`/pay/wxMch/download/privateCert/${id}`)
}
// 微信商户管理 下载私钥证书文件
export const downloadWechatShopPrivateKey = (id, filename = '私钥') => {
  return request.get(`/pay/wxMch/download/privateKey/${id}`)
}
// 微信商户管理 下载私钥证书文件
export const downloadWechatShopPublicKey = (id, filename = '公钥') => {
  return request.get(`/pay/wxMch/download/publicKey/${id}`)
}

// 微信商户管理 执行定时器 page
export const pageWxMchScheduleApi = (params) => {
  return request.post('/pay/wxMchSchedule/page', params)
}

// 微信商户管理 执行定时器 删除
export const delWxMchScheduleApi = (id) => {
  return request.post(`/pay/wxMchSchedule/del/${id}`)
}

// 微信商户管理 执行定时器 保存
export const saveWxMchScheduleApi = (params) => {
  return request.post('/pay/wxMchSchedule/save', params)
}
